<section class="page-card">
  <app-back-button-component />

  <div class="section-kicker">Lore Entry</div>
  <h2 class="section-title">About Character Codex</h2>
  <p class="empty-copy">
    Character Codex is a campaign companion for tracking worlds, characters, sessions, and the
    small details that turn notes into living lore. Think of it as a traveling DM screen crossed
    with an adventurer's archive.
  </p>
</section>
